module.exports = __webpack_public_path__ + "static/media/history.74a12580.jpg";